import { defineComponent as _defineComponent } from 'vue';
import { SIcon } from '@strana-artw/ui-kit';
import { defineComponent } from 'vue';
import { NavButton } from '@/shared/ui';
export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderButtonMenu',
  setup: function setup(__props) {
    defineComponent({
      name: 'HeaderButtonMenu'
    });
    return {
      __sfc: true,
      SIcon: SIcon,
      NavButton: NavButton
    };
  }
});